import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { QuoteSimulator } from "../components/QuoteSimulator";
import { useI18n } from "../context/I18nContext";

export default function SimulateurPage() {
  const { t } = useI18n();
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100">
      <Navbar />
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-6 sm:px-12 pt-16 pb-4">
          <p className="text-xs font-semibold tracking-[0.3em] uppercase text-zinc-500 mb-4">
            {t("sim.label")}
          </p>
          <h1 className="font-display text-4xl sm:text-6xl tracking-tighter max-w-3xl">
            {t("sim.title_a")}
            <em className="italic text-zinc-400">{t("sim.title_em")}</em>
            {t("sim.title_b")}
          </h1>
          <p className="mt-6 text-zinc-400 max-w-xl text-base sm:text-lg">{t("sim.intro")}</p>
        </div>
        <QuoteSimulator compact />
      </main>
      <Footer />
    </div>
  );
}
